const auditTypeEnum =
    {
        passed:'已通过',
        rejected:'已拒绝',
        drafted:'草稿',
        submitted:'已提交',
        canceled:'已取消'
    }


export default auditTypeEnum;